import React, { Component } from 'react';
import getPreRequisites from './helpers/getPreRequisites';
import checkForPreRequisitesCompletion from './helpers/checkForPreRequisitesCompletion';

export default function withPreRequisiteCheck(OriginalComponent) {
  class PreRequisiteCheck extends Component {
    async componentDidMount() {
      if (this.props.isLiveClass) {
        return;
      }

      if (this.props.match && this.props.match.params) {
        const preReqs = await getPreRequisites(this.props.match.params.courseId);
        const preReqDone = checkForPreRequisitesCompletion(preReqs);

        if (!preReqDone) {
          window.location.hash = window.location.hash.split('/card')[0] + '/pre-requisites';
        }
      }
    }

    render() {
      return (
        <React.Fragment>
          <OriginalComponent {...this.props} />
        </React.Fragment>
      );
    }
  }

  return PreRequisiteCheck;
}
